var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5859_1008)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.02133 2.24341C2.44929 1.40358 4.25536 -0.0512399 8.05601 0.848194C11.8566 1.74763 13.2798 1.13325 14.0587 0.189453C14.4182 2.70101 15.1287 6.86889 15.439 8.63889C14.8178 9.39634 12.0428 10.259 9.37213 8.98772C6.70143 7.71643 4.212 9.04629 3.24901 9.9119L2.02133 2.24341ZM1.3064 1.7947C1.27382 1.59017 1.0816 1.45079 0.877074 1.48337C0.672546 1.51596 0.53316 1.70817 0.565746 1.9127L2.72953 15.4939C2.76212 15.6984 2.95434 15.8378 3.15886 15.8052C3.36339 15.7727 3.50278 15.5804 3.47019 15.3759L1.3064 1.7947Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5859_1008"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.8b482be3b94d0b458467a07512639e6f.svg";
export { ForwardRef as ReactComponent };